var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFoodproductionSupplychain(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.793,
    height: 29.833,
    viewBox: "0 0 19.793 29.833",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1065",
    "data-name": "Groupe 1065",
    transform: "translate(-919.678 -762.914)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_10415",
    "data-name": "Trac\\xE9 10415",
    d: "M924.781,772.178v21.747H920.3a.619.619,0,0,1-.621-.621v-21.44a1.943,1.943,0,0,1,.276-1.013c.2-.353,1.327-1.826,2.133-2.877.8,1.1,2.186,3.007,2.363,3.322A2.99,2.99,0,0,1,924.781,772.178Z",
    transform: "translate(0 -1.178)",
    fill: "#77a395"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_10416",
    "data-name": "Trac\\xE9 10416",
    d: "M940.06,769.8l-2.854-4.089v-2.033a.769.769,0,0,0-.767-.767H924.687a.769.769,0,0,0-.767.767v2.033h.008v.008c.153.215,2.669,3.651,2.915,4.081a2.988,2.988,0,0,1,.33.882v22.062h12.665a.619.619,0,0,0,.621-.621V770.685A1.909,1.909,0,0,0,940.06,769.8Zm-4.727-1.9-.581,1.277a2.353,2.353,0,0,1-1.838.983,3.211,3.211,0,0,1-2.979-2.076,1.987,1.987,0,0,1,0-1l.839-1.434.008,0a2.052,2.052,0,0,1,1.814-1.011,3.143,3.143,0,0,1,2.884,1.949,1.552,1.552,0,0,1-.155,1.3Z",
    transform: "translate(-0.988 0)",
    fill: "#77a395"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoodproductionSupplychain);
export default __webpack_public_path__ + "static/media/foodproduction_supplychain.aa907fa5d9f9efaa17a666fb592bdaf5.svg";
export { ForwardRef as ReactComponent };